/* eslint-disable functional/prefer-readonly-type */
/* eslint-disable react/iframe-missing-sandbox */
/* eslint-disable functional/immutable-data */

import React, { useEffect } from 'react';
import { Platform, View } from 'react-native';
import type WebView from 'react-native-webview';
import type { WebViewSourceHtml } from 'react-native-webview/lib/WebViewTypes';

import { FRAME_ID } from './constants';

export const HostedFieldsFrame = ({
  source,
  containerStyle,
  isLoadingFields,
  onMessage,
}: HostedFrameProps) => {
  useBraintreeScriptLoader(source?.html ?? '', onMessage);

  return (
    <View style={containerStyle}>
      <iframe
        id={FRAME_ID}
        style={isLoadingFields ? frameLoadingStyle : frameStyle}
        title="Credit Card Form"
        src="about:blank"
      />
    </View>
  );
};

const useBraintreeScriptLoader = (
  source: string,
  onMessage?: React.ComponentProps<typeof WebView>['onMessage'],
) => {
  useEffect(() => {
    const frame = document.querySelector<HTMLIFrameElement>(`#${FRAME_ID}`);

    if (!frame) return;

    frame.srcdoc = source;

    const getData = (message: MessageEvent) => {
      if (!message.data.includes?.('fromHostedFrame')) return;

      onMessage?.({ nativeEvent: { data: message.data } } as never);
    };

    window.addEventListener('message', getData, false);

    return () => {
      window.removeEventListener('message', getData, false);
    };
  }, [source, onMessage]);
};

// ─── Helpers ────────────────────────────────────────────────────────
export const tokenizeWebCreditCard = () => {
  if (Platform.OS !== 'web') return;

  const frame = document.querySelector(`#${FRAME_ID}`);

  if (!frame) return;

  const withContentWindow = frame as unknown as {
    contentWindow: { tokenizeCreditCard: () => void };
  };

  withContentWindow.contentWindow.tokenizeCreditCard();
};

// ─── Types ──────────────────────────────────────────────────────────
type HostedFrameProps = Pick<
  React.ComponentProps<typeof WebView>,
  'containerStyle' | 'onMessage'
> & {
  readonly source: WebViewSourceHtml;
  readonly isLoadingFields?: boolean;
};

// ─── Styles ─────────────────────────────────────────────────────────
const frameStyle = { border: 0, height: 270 };
const frameLoadingStyle = { border: 0, height: 1 };
